import React from 'react';
import classnames from 'classnames';

class Minimal extends React.PureComponent {
  render() {
    const classes = classnames({
      template: true,
      minimal: true,
    });
    return <div className={classes}>{this.props.content}</div>;
  }
}

export default Minimal;
